import { useState, useEffect } from "react";

function TextSlider() {
  const texts = [
    "We deliver high-quality products",
    "Customer satisfaction is our priority",
    "Innovation and excellence since 2025",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [texts.length]);

  return (
    <div className="w-full py-10 sm:py-16 md:py-20 flex items-center justify-center bg-white text-black mb-8 sm:mb-12">
      <h2 className="text-xl sm:text-2xl md:text-3xl italic font-semibold text-center px-4 break-words leading-snug">
        {texts[index]}
      </h2>
    </div>
  );
}

export default TextSlider;
